module.exports = __webpack_public_path__ + "img/s3on.99bfef68.svg";